import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import Notiflix from "notiflix";

//ANT DESIGN IMPORTS
import { Row, Typography, Card, Spin, Form, Divider, Col, Collapse, Dropdown } from "antd";

//ANT DESIGN ICONS IMPORTS
import { SettingOutlined } from "@ant-design/icons";

//PROJECT IMPORTS
import TopContent from "../../../../components/layouts/TopContent";
import { BOM } from "../../../../services/definedMethod";
import cnt from "../../../../services/definedConstant";
import "../../../../assets/styles/DatePicker.css";
import MainLayout from "../../../../components/layouts/MainLayout";
import { apiConfig, labelConfig, staticConfig } from "../../customer.config";
import {
  AccountFacility,
  accountStatus,
  AmountFormat,
  handleFlgStatus,
  handleRecurringDepositAccActionButtons,
  isDebit,
} from "../../../../components/facilities/AccountFacility";
import InterestRateChart from "./tabs/InterestRateChart";
import tabList from "./tabs/tabList.json";
import Charges from "./tabs/Charges";
import Transactions from "./tabs/transactions/Transactions";
import { rightAction } from "../../../../redux/actions";
import { showCheckerApprovalModal } from "../../../../components/CheckerModal";

const { Text, Title } = Typography;
const { Panel } = Collapse;

const DetailRecurringDepositAccount = (props) => {
  //DECLARED VARIABLES
  const { userData, rightAction } = props;
  const { session } = userData;
  const navigate = useNavigate();
  const { state } = useLocation();
  const [useForm] = Form.useForm();
  const [accountDetails, setAccountDetails] = useState([]);
  const [interestRateChartList, setInterestRateChartList] = useState([]);
  const [chargesList, setChargesList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [transactionsList, setTransactionsList] = useState([]);
  const [activeTabKey, setActiveTabKey] = useState("interestRateChart");
  const [currentPage, setCurrentPage] = useState(1);
  const [tableCount, setTableCount] = useState(25);
  const [totalItems, setTotalItems] = useState(0);
  const [menuProps, setMenuProps] = useState({
    items: [],
  });

  useEffect(() => {
    {
      BOM.HasPermission("READ_RECURRINGDEPOSITACCOUNT") && getDetailById();
    }
    getNotes();
  }, []);

  console.log(accountDetails);

  const getDetailById = (offset = 0, _limit = Number(tableCount)) => {
    setIsLoading(true);
    const params = {
      associations: "all",
      offset: offset,
      limit: _limit,
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;
    let body = {
      session,
      params,
    };

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        setAccountDetails(objDetail);

        console.log(objDetail);

        let tempInterestRateChartArray = [];
        let tempTransactionsArray = [];
        let tempChargesArray = [];

        objDetail?.accountChart?.chartSlabs?.forEach((element) => {
          tempInterestRateChartArray.push({
            key: element?.id,
            id: element?.id,
            periodType: element?.periodType ? element?.periodType?.value : "-",
            periodFromTo: `${element?.fromPeriod ? element?.fromPeriod : "-"} / ${
              element?.toPeriod ? element?.toPeriod : "-"
            }`,
            amountRange: `${element?.amountRangeFrom ? element?.amountRangeFrom : "-"} / ${
              element?.amountRangeTo ? element?.amountRangeTo : "-"
            }`,
            interest: element?.annualInterestRate ? element?.annualInterestRate : "-",
            description: element.description ? element.description : "-",
          });
        });

        objDetail?.transactions?.forEach((element, i) => {
          const shouldFilterOut = element?.transactionType?.interestPosting && !element?.amount;
          console.log(shouldFilterOut, element.transactionType?.interestPosting, element.amount);
          if (i < 2000) {
            // TODO: Remove this hardcoded value
            return tempTransactionsArray.push({
              key: element?.id,
              id: element?.id,
              transactionDate: element?.date ? BOM.DateTime(element?.date, "only-date") : "-",
              transactionType: element?.transactionType ? element?.transactionType?.value : "-",
              debit: isDebit(element?.transactionType)
                ? BOM.TruncateDecimal(element?.amount, 2)
                : "-",
              credit: !isDebit(element?.transactionType)
                ? BOM.TruncateDecimal(element?.amount, 2)
                : "-",
              balance: element?.runningBalance
                ? `${element?.currency?.code} ${BOM.TruncateDecimal(element?.runningBalance, 2)}`
                : "-",
            });
          }
        });

        objDetail?.charges?.forEach((element) => {
          tempChargesArray.push({
            key: element?.id,
            id: element?.id,
            name: element?.name ? BOM.SubstringFormat(element?.name, 20) : "-",
            penalty: element?.penalty ? "Penalty" : "Fee",
            paymentDueAt: element?.chargeTimeType?.value ? element?.chargeTimeType?.value : "-",
            dueAsOf: element?.dueDate ? BOM.DateTime(element?.dueDate, "only-date") : "-",
            repeatsOn: element?.feeOnMonthDay
              ? BOM.DateTimeWithoutYear(element?.feeOnMonthDay, "only-date")
              : "-",
            calculationType: element?.chargeCalculationType?.value
              ? element?.chargeCalculationType?.value
              : "-",
            due: element?.currency?.code
              ? `${element?.currency?.displaySymbol} ${element?.amountOrPercentage}`
              : "-",
            paid: element?.currency?.code
              ? `${element?.currency?.displaySymbol} ${Number(
                  element?.amountPaid,
                ).toLocaleString()}`
              : "-",
            waived: element?.currency?.code
              ? `${element?.currency?.displaySymbol} ${Number(
                  element?.amountWaived,
                ).toLocaleString()}`
              : "-",
            outstanding: element?.currency?.code
              ? `${element?.currency?.displaySymbol} ${Number(
                  element?.amountOutstanding,
                ).toLocaleString()}`
              : "-",
            status: handleFlgStatus(element?.isActive ? "active" : "closed", {}, true),
          });
        });

        setTransactionsList(tempTransactionsArray);
        setTotalItems(tempTransactionsArray.length);
        console.log(tempTransactionsArray.length);

        /**
         * ON CLICK ACTION MENU
         */
        setMenuProps({
          items: handleRecurringDepositAccActionButtons(objDetail),
          onClick: (e) => {
            const item = handleRecurringDepositAccActionButtons(objDetail).find(
              (element) => element.key === e.key,
            );

            if (item) {
              switch (item?.label.toLowerCase()) {
                case "calculate interest":
                  return calculateInterest();
                case "post interest":
                  return postInterest();
                case "disable withhold tax":
                  return disableWithholdTax();
                case "enable withhold tax":
                  return enableWithholdTax();

                default:
                  //ROUTE REDIRECTING ACTIONS
                  return navigate(item.route, {
                    state: {
                      ...state,
                      accountNo: objDetail.accountNo,
                      actionLabel: item.label,
                    },
                  });
              }
            }
          },
        });

        setInterestRateChartList(tempInterestRateChartArray);
        setChargesList(tempChargesArray);

        /**
         * ACTIVATE DELETE RIGHT BUTTON ACTION
         */
        if (objDetail?.status?.value.toLowerCase() === accountStatus.submittedAndPending) {
          BOM.HasPermission("DELETE_RECURRINGDEPOSITACCOUNT") && rightAction(cnt.RIGHT_DELETE_BTN);
        }

        /**
         * STOP LOADER
         */
        setIsLoading(false);
      }
    });
  };
  const onRefresh = (offset = 0, limit = Number(tableCount)) => {
    getDetailById(offset, limit);
    setCurrentPage(1);
  };
  const getNotes = () => {
    setIsLoading(true);

    const url = `${apiConfig.Savings}/${state.id}/notes`;

    let body = {
      session,
    };

    /** FETCH ROLE */
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        const objDetail = res;
        // setAccountDetails(objDetail);

        let tempMemoArray = [];

        objDetail?.forEach((element) => {
          tempMemoArray.push({
            key: element?.id,
            memoId: element?.id,
            createdBy: element?.createdByUsername ? element?.createdByUsername : "-",

            memo: element?.note ? element?.note : "-",
            createdOn: element?.createdOn ? element?.createdOn : "-",
          });
        });

        setIsLoading(false);
      }
    });
  };
  function postInterest() {
    setIsLoading(true);
    const params = {
      command: "postInterest",
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Recurring Deposit Account Interest was succesfully posted");
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      },
    );
  }

  function calculateInterest() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Recurring Deposit Account Interest was succesfully calculated",
          );
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      },
    );
  }

  function Withdraw() {
    setIsLoading(true);
    const params = {
      command: "calculateInterest",
    };
    const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;

    let body = {
      session,
      params,
      method: "POST",
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(
            cnt.SUCCESS,
            "Recurring Deposit Account Interest was succesfully calculated",
          );
          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      },
    );
  }

  function disableWithholdTax() {
    setIsLoading(true);
    const params = {
      command: "updateWithHoldTax",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      withHoldTax: false,
      session,
      method: "PUT",
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Fixed Deposit Account was succesfully disabled");
          getDetailById();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      },
    );
  }

  function enableWithholdTax() {
    setIsLoading(true);
    const params = {
      command: "updateWithHoldTax",
    };
    const url = `${apiConfig.savingsAccounts}/${state.id}`;

    let body = {
      withHoldTax: true,
      session,
      method: "PUT",
      params,
    };

    BOM.FetchReqAction(
      body,
      url,
      (err, res) => {
        if (err) {
          BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
          setIsLoading(false);
        } else {
          BOM.AlertMsg(cnt.SUCCESS, "Fixed Deposit Account was succesfully enabled");
          getDetailById();

          //STOP LOAD
          setIsLoading(false);
        }
      },
      {
        navigate,
        showCheckerModal: showCheckerApprovalModal,
        onCheckerApproval: (res) => {
          // navigate(0);
          setIsLoading(false);
        },
      },
    );
  }
  const onTabChange = (key) => {
    setActiveTabKey(key);
  };
  const handleOnDelete = () => {
    let action = "Close Account  ";
    let accountNo = accountDetails.accountNo;

    Notiflix.Confirm.show(
      "Are you sure?",
      action + accountNo,
      "Yes",
      "No",

      function () {
        setIsLoading(true);
        const url = `${apiConfig.Recurringdepositaccounts}/${state.id}`;
        let body = {
          session,
          method: "DELETE",
          session,
        };
        BOM.FetchReqAction(
          body,
          url,
          (err, res) => {
            if (err) {
              BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
              //STOP LOAD
              setIsLoading(false);
            } else {
              BOM.AlertMsg(cnt.SUCCESS, labelConfig.deleteRecurringDepositAccountMsg);
              navigate("/acc0107");
              //STOP LOAD
              setIsLoading(false);
            }
          },
          {
            navigate,
            showCheckerModal: showCheckerApprovalModal,
            onCheckerApproval: (res) => {
              navigate("/acc0107");
              setIsLoading(false);
            },
          },
        );
      },

      function () {
        // No button
      },
    );
  };

  const contentListNoTitle = {
    interestRateChart: <InterestRateChart interestRateChartList={interestRateChartList} />,
    transactions: (
      <Transactions
        transactionsList={transactionsList}
        userData={userData}
        state={state}
        refreshList={getDetailById}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        tableCount={tableCount}
        setTableCount={setTableCount}
        totalItems={totalItems}
        setTotalItems={setTotalItems}
        onRefresh={onRefresh}
      />
    ),
    charges: (
      <Charges
        chargesList={chargesList}
        setChargesList={setChargesList}
        state={state}
        userData={userData}
        refreshDetail={getDetailById}
        refreshNote={getNotes}
      />
    ),
  };

  return (
    <MainLayout isEnableRightSidebar={true} onDelete={handleOnDelete}>
      {/* PART 1  IMPORT TOP CONTENT*/}
      <TopContent
        pageTitle={labelConfig.detailRecurringDepositAccount}
        pageItems={staticConfig.detailRecurringDepositAccountBreadcrumbItems}
      />

      <Spin spinning={isLoading} size="large">
        <Card
          style={{
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
          }}
        >
          <Form form={useForm} layout="vertical" style={{ paddingTop: 20, marginBottom: 50 }}>
            <Row>
              <Title level={4} style={{ margin: 0, marginBottom: 0 }}>
                {labelConfig.generalInfo}
              </Title>
            </Row>
            <Divider style={{ marginTop: 10 }} />

            <Row style={{ marginBottom: 30, padding: 10 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Dropdown.Button menu={menuProps} icon={<SettingOutlined />} placement="topLeft">
                  Actions
                </Dropdown.Button>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <AccountFacility
                  accountName={accountDetails?.clientName}
                  accountNo={accountDetails?.accountNo}
                  status={accountDetails?.status}
                />
              </Col>
            </Row>
            <Row style={{ marginBottom: 30 }}>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.currentBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.accountBalance}
                    precision={2}
                  />
                </Card>
              </Col>

              <Col span={12} style={{ padding: "0px 8px" }}>
                <Card
                  bordered={true}
                  bodyStyle={{
                    paddingTop: 17,
                    paddingBottom: 17,
                    paddingLeft: 24,
                  }}
                  hoverable={true}
                  style={{ marginBottom: 16 }}
                >
                  <AmountFormat
                    labelName={labelConfig.availableBalance}
                    currency={accountDetails?.currency?.code}
                    amount={accountDetails?.summary?.accountBalance}
                    precision={2}
                  />
                </Card>
              </Col>
            </Row>

            <Row>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <RecurringDepositDetails accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <PerformanceHistory accountDetails={accountDetails} />
              </Col>
              <Col span={12} style={{ padding: "0px 8px" }}>
                <InterestDetails accountDetails={accountDetails} />
              </Col>
            </Row>
          </Form>
        </Card>
        <Card
          headStyle={{ borderBottomWidth: 0 }}
          style={{
            width: "100%",
            boxShadow: "0px 0px 30px 3px rgba(0,0,0,0.1)",
            borderRadius: 20,
            marginTop: 24,
          }}
          tabList={tabList}
          activeTabKey={activeTabKey}
          onTabChange={onTabChange}
          tabProps={{
            size: "middle",
          }}
        >
          {contentListNoTitle[activeTabKey]}
        </Card>
      </Spin>
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
const mapDispatchToProps = { rightAction };

export default connect(mapStateToProps, mapDispatchToProps)(DetailRecurringDepositAccount);

function RecurringDepositDetails(props) {
  const { accountDetails } = props;

  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.accountInfo}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.accountOfficer}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.fieldOfficerName ? accountDetails?.fieldOfficerName : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.activationDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.timeline?.activatedOnDate
                  ? BOM.FormatArrayDate(accountDetails?.timeline?.activatedOnDate)
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.maturityDate
                  ? BOM.FormatArrayDate(accountDetails?.maturityDate)
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.period}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.depositPeriod
                  ? `${accountDetails?.depositPeriod} ${accountDetails?.depositPeriodFrequency?.value}`
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.depositFrequency}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.recurringFrequency
                  ? `${accountDetails?.recurringFrequency} ${accountDetails?.recurringFrequencyType?.value}`
                  : " - "}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.withholdTaxAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.status?.prematureClosed
                  ? accountDetails?.summary?.totalWithholdTax?.toLocaleString()
                  : accountDetails?.calculatedWithHoldTax
                    ? accountDetails?.calculatedWithHoldTax?.toLocaleString()
                    : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        {accountDetails?.withHoldTax && (
          <div
            style={{
              border: "2px solid #F5F5F5",
              borderRadius: 0,
              borderBottomColor: "#E2E2E2",
            }}
          >
            <Row>
              <Col
                span={12}
                style={{
                  backgroundColor: "#F5F5F5",
                  padding: 10,
                  borderRadius: 0,
                }}
              >
                <Text strong>{labelConfig.withholdTaxGroup}</Text>
              </Col>
              <Col
                span={12}
                style={{
                  padding: 10,
                }}
              >
                <Text style={{ color: "#b8b8b8" }}>
                  {accountDetails?.taxGroup ? accountDetails?.taxGroup?.name : "-"}
                </Text>
              </Col>
            </Row>
          </div>
        )}
      </Panel>
    </Collapse>
  );
}

function PerformanceHistory(props) {
  const { accountDetails } = props;
  const maturityInterest = accountDetails?.maturityAmount - accountDetails?.depositAmount || "0";
  const withHoldTax = accountDetails?.withHoldTax;
  const netInterest = withHoldTax
    ? Number(maturityInterest) - Number(accountDetails?.calculatedWithHoldTax || 0)
    : Number(maturityInterest);
  const maturityAmount = withHoldTax
    ? Number(accountDetails?.depositAmount) + Number(netInterest)
    : Number(accountDetails?.maturityAmount);

  console.log(maturityInterest, "maturityInterest");
  console.log(netInterest, "netInterest");
  console.log(maturityAmount, "maturityAmount");
  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.performanceHistory}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderBottomLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.principalAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.depositAmount
                  ? BOM.TruncateDecimal(accountDetails?.depositAmount, 2)
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {Number(maturityInterest) ? BOM.TruncateDecimal(maturityInterest, 2) : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.netInterest}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {String(netInterest) ? BOM.TruncateDecimal(netInterest, 2) : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.maturityAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {String(maturityAmount) ? BOM.TruncateDecimal(maturityAmount, 2) : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestEarned}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalInterestEarned
                  ? BOM.TruncateDecimal(accountDetails?.summary?.totalInterestEarned, 2)
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPosted}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.totalInterestPosted
                  ? BOM.TruncateDecimal(accountDetails?.summary?.totalInterestPosted, 2)
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.recurringDepositAmount}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.mandatoryRecommendedDepositAmount
                  ? BOM.TruncateDecimal(accountDetails?.mandatoryRecommendedDepositAmount, 2)
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.depositsToDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.summary?.accountBalance
                  ? BOM.TruncateDecimal(accountDetails?.summary?.accountBalance, 2)
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.withdrawalsToDate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                <Text style={{ color: "#b8b8b8" }}>
                  {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                  {accountDetails?.withdrwalsTillDate
                    ? BOM.TruncateDecimal(accountDetails?.withdrwalsTillDate, 2)
                    : "0"}
                </Text>
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}

function InterestDetails(props) {
  const { accountDetails } = props;
  console.log(accountDetails?.minBalanceForInterestCalculation);
  return (
    <Collapse
      style={{
        boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
        marginBottom: 25,
      }}
    >
      <Panel
        header={
          <Title level={5} style={{ margin: 0 }}>
            {labelConfig.financialInformation}
          </Title>
        }
        key="1"
      >
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.nominalInterestRate}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.nominalAnnualInterestRate
                  ? `${accountDetails?.nominalAnnualInterestRate}%`
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCompoundingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCompoundingPeriodType
                  ? accountDetails?.interestCompoundingPeriodType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestPostingPeriod}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestPostingPeriodType
                  ? accountDetails?.interestPostingPeriodType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 0,
            borderBottomColor: "#E2E2E2",
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 0,
              }}
            >
              <Text strong>{labelConfig.interestCalculatedUsing}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationType
                  ? accountDetails?.interestCalculationType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.daysInYear}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.interestCalculationDaysInYearType
                  ? accountDetails?.interestCalculationDaysInYearType?.value
                  : "-"}
              </Text>
            </Col>
          </Row>
        </div>
        <div
          style={{
            border: "2px solid #F5F5F5",
            borderRadius: 15,
            borderTopLeftRadius: 0,
            borderTopRightRadius: 0,
          }}
        >
          <Row>
            <Col
              span={12}
              style={{
                backgroundColor: "#F5F5F5",
                padding: 10,
                borderRadius: 15,
                borderTopRightRadius: 0,
                borderBottomRightRadius: 0,
                borderTopLeftRadius: 0,
              }}
            >
              <Text strong>{labelConfig.balanceForInterestCalculation}</Text>
            </Col>
            <Col
              span={12}
              style={{
                padding: 10,
              }}
            >
              <Text style={{ color: "#b8b8b8" }}>
                {accountDetails?.currency?.code ? accountDetails?.currency?.code : "-"}{" "}
                {accountDetails?.minBalanceForInterestCalculation
                  ? Number(accountDetails?.minBalanceForInterestCalculation).toLocaleString()
                  : "0"}
              </Text>
            </Col>
          </Row>
        </div>
      </Panel>
    </Collapse>
  );
}
